import { Appear, ProgressSpinner } from '@bitrise/bitkit';
import React, { FunctionComponent } from 'react';

const MessageFetching: FunctionComponent<{ fetching: boolean }> = (props) => {
  const { fetching } = props;

  return (
    <Appear
      absolute="center"
      animation="Fade"
      style={{ pointerEvents: fetching ? undefined : 'none' }}
      visible={fetching}
    >
      <ProgressSpinner textColor="gray-5" />
    </Appear>
  );
};

export default MessageFetching;
